
// Linked List of Promises used for running multiple
// queries one after another
class LinkedPromiseList {
    constructor(currentPromise, nextPromise) {
        // currentPromise is the current batch of results
        // nextPromise resolves to next LinkedPromiseList
        this.currentPromise = currentPromise;
        this.nextPromise = nextPromise;
    }

    // executes the promise at the head of the linked list
    async getCurrent() {
        return await this.currentPromise();
    }

    // returns the remainder of the linked list (executing the
    // promise that generates this remainder)
    async getNext() {
        return await this.nextPromise;
    }
}

export default LinkedPromiseList;
